exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.table-resumen[data-v-632a5f6c]{border-width:0}table.table-resumen tbody[data-v-632a5f6c]{border-style:solid;border-color:#05bdbd;border-width:1px 0 0 1px}table.table-resumen td[data-v-632a5f6c]{border-color:#05bdbd;border-width:0 1px 1px 0}.destacado[data-v-632a5f6c]{background-color:#05bdbd;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-632a5f6c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/BookingConfirmation.vue
// module id = 534
// module chunks = 0